import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChangeControlConstants } from '../../constants/changeControlConstants';
import { BehaviorSubject } from 'rxjs';
import { ChangeControlPersistenceService } from '../../services/change-control-persistence.service';

@Component({
  selector: 'app-previous-phase',
  templateUrl: './previous-phase.component.html',
  styleUrls: ['./previous-phase.component.scss']
})
export class PreviousPhaseComponent implements OnInit {
  @Output() isPreviousPhaseModalVisible=new EventEmitter<boolean>();
  @Input() changeControlNumber: string | null = null;
  toolTip: string = ChangeControlConstants.ChangeControl_PreviousPhase_ToolTip
  isDisable: boolean = false;
  

  myBehaviorSubject = new BehaviorSubject<boolean>(false);
  
  constructor(private changeControlPersistenceService: ChangeControlPersistenceService) { }

  ngOnInit(): void {
    this.SetPreviousPhase();
  }

  SetPreviousPhase(){
    this.changeControlPersistenceService.previousPhaseButtonDisable$.subscribe((data) => {
      this.isDisable = data;
    });
    
    this.changeControlPersistenceService.previousPhaseButtonToolTip$.subscribe((data) => {
      this.toolTip = data;
    });
  }

  ChangeControlPreviousPhase(){
    this.isPreviousPhaseModalVisible.emit(true);
  }
}
